module.exports = __webpack_public_path__ + "static/media/logo.f07edb32.png";